import PropTypes from "kf-proptypes";

//add service specific proptyes in PROP_TYPES
const PROP_TYPES = { ...PropTypes };

export default PROP_TYPES;
